/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable block-scoped-var */
/* eslint-disable no-else-return */
/* eslint-disable dot-notation */
import { Component, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

import {
  ErroMessages,
  IErroMessages,
  IRoute,
  TokenService,
  User,
  UserService
} from 'viggo-sistemas-core-web';

import { HttpErrorResponse } from '@angular/common/http';
import { IContratoPrecificacao } from '@app/modules/precificacao/contrato_precificacao/models/contrato_precificacao.model';
import { ContratoPrecificacaoService } from '@app/modules/precificacao/contrato_precificacao/services/contrato_precificacao.service';
import { ConfirmDialogComponent, ConfirmDialogData } from '@app/shared/components';
import {
  IPrimeirosPassos,
  ISubPasso
} from '@app/shared/utils/primeiros_passos/settings_primeiros_passos';
import { ValidadorSettingsApplication } from '@app/shared/utils/validar_settings_application';
import { ValidadorSettingsDomain } from '@app/shared/utils/validar_settings_domain';

interface EventItem {
  status?: string;
  date?: string;
  icon?: string;
  color?: string;
  image?: string;
  description?: string;
  flag?: string;
  toolTip?: string;
  finish?: boolean;
  link?: ISubPasso[];
  index?: number;
}

@Component({
  selector: 'first-steps',
  templateUrl: './first-steps.component.html',
  styleUrls: ['./first-steps.component.scss'],
  providers: [ContratoPrecificacaoService]
})
export class FirstStepsComponent implements OnInit {
  passos = [] as IPrimeirosPassos[];
  loading = false;
  events: EventItem[] = [];
  public showError = false;
  errorObj = {
    title: 'Erro detectado',
    srcImg: './assets/images/access_denied.svg',
    classImg: 'content-img',
    message: 'Erro detectado'
  } as {
    title: string;
    srcImg: string;
    classImg: string;
    message: string;
  };

  constructor(
    private renderer: Renderer2,
    private tokenService: TokenService,
    private userService: UserService,
    public router: Router,
    public matDialog: MatDialog,
    public matSnackBar: MatSnackBar,
    protected contratoService: ContratoPrecificacaoService
  ) {}

  validateRules(dadosempresa) {
    dadosempresa.application.settings = new ValidadorSettingsApplication(
      dadosempresa.application.settings
    ).getApplicationSettingsBody(dadosempresa.application.settings) as any;
    if (
      dadosempresa.application.settings.regras !== undefined &&
      dadosempresa.application.settings.regras.usa_integracao
    )
      localStorage.setItem(
        'INTEGRACAO',
        dadosempresa.application.settings.regras.usa_integracao
      );
    else localStorage.setItem('INTEGRACAO', 'false');
  }

  ngOnInit(): void {
    this.loading = true;
    this.contratoService
      .getEntitiesByParams(
        `id=${
          this.tokenService.getDomain().id
        }&page=0&page_size=1&include=plano`,
        undefined,
        true
      )
      .subscribe(
        (vl: { data: IContratoPrecificacao[]; pagination: any }) => {
          if (vl.data.length !== 0) {
            this.showError = false;
            localStorage.setItem('possuiPlano', 'true');
            this.userService.getRoutes().subscribe(routes => {
              this.tokenService.setRoutes(routes);
              const domain = this.tokenService.getDomain();
              domain.settings = new ValidadorSettingsDomain(
                domain.settings,
                domain.application.settings,
                this.checkPlano(vl.data[0].plano.nome)
              ).getDomainSettingsBody(domain.settings) as any;
              this.validateRules(domain);
              if (
                this.isUserAdmin() &&
                domain.settings['config_inicial'].ultimo_passo === 'UNKNOWN'
              ) {
                this.passos = domain.settings['config_inicial'].passos;
                this.buildTimeline();
                if (!this.dialogOpened()) {
                  localStorage.setItem('dialogOpened', 'true');
                  this.matDialog.open(ConfirmDialogComponent, {
                    data: {
                      title: 'Primeiros passos',
                      bodyMessage:
                        'Bem-vindo! Identificamos que esse é seu primeiro contato com a plataforma. Então, para uma melhor experiência precisamos configurar algumas informações sobre sua empresa. Vamos lá?',
                      icon: 'directions_run',
                      icon_color: 'primary',
                      singleBtn: true
                    },
                    width: '400px',
                    panelClass: ['custom-container', 'position-relative']
                  });
                }
              } else if (
                this.isUserAdmin() &&
                !this.dialogConcluidedOpened() &&
                (domain.settings['config_inicial'].ultimo_passo ===
                  'FINALIZADO' ||
                  domain.settings['config_inicial'].ultimo_passo ===
                    'FINALIZADO_PARCIAL')
              ) {
                localStorage.setItem('dialogConcluidedOpened', 'true');
                this.matDialog
                  .open(ConfirmDialogComponent, {
                    data: {
                      title: 'Parabéns!',
                      bodyMessage:
                        'Pronto, agora todo o sistema ViTex está configurado e pronto para uso. Aproveite e qualquer outra dúvida entre em contato.',
                      icon: 'check_circle',
                      icon_color: 'primary',
                      singleBtn: true
                    },
                    width: '400px',
                    panelClass: ['custom-container', 'position-relative']
                  })
                  .afterClosed()
                  .subscribe(() => this.router.navigate(['/workspace']));
              } else {
                this.passos = domain.settings['config_inicial'].passos;
                this.buildTimeline();
              }
            });
          }
        },
        (err: HttpErrorResponse) => {
          this.showError = true;
          this.loading = false;
          this.displayError(err, true);
        }
      );
  }

  buildTimeline() {
    var index = 1;
    this.passos.forEach(passo => {
      this.events.push({
        status: passo.titulo,
        description: passo.descricao,
        color: passo.color,
        icon: passo.icon,
        image: passo.image,
        flag: passo.passo_valor,
        toolTip: passo.toolTip,
        link: passo.link,
        finish: passo.concluido,
        index: index++
      });
    });
    this.loading = false;
  }

  disabledButton(passo_valor: string) {
    const domain = this.tokenService.getDomain();
    if (domain) {
      domain.settings = new ValidadorSettingsDomain(
        domain.settings
      ).getDomainSettingsBody(domain.settings) as any;
      const index = this.events.findIndex(it => it.flag === passo_valor);
      if (index >= 0) {
        if (index === 0) return false;
        else return !this.events[index - 1].finish;
      }
    } else return true;
  }

  sendTo(passo_link: ISubPasso[]) {
    const notAccess =
      passo_link.length > 1
        ? passo_link.find(it => !it.concluido)
        : passo_link[0];
    this.router.navigate([notAccess.url]);
  }

  dialogOpened() {
    return localStorage.getItem('dialogOpened') === 'true';
  }

  dialogConcluidedOpened() {
    return localStorage.getItem('dialogConcluidedOpened') === 'true';
  }

  /**
   * Valida as rotas do usuário
   * @param routes
   * @param url_name
   * @returns
   */
  verificarRotasDeAcesso(routes: IRoute[], url_name: string): IRoute[] {
    if (routes && routes.length > 0 && url_name) {
      return routes.filter(r => new RegExp(`^${url_name}`).test(r.url));
    }
  }

  /**
   * Valida se as rotas do usuário são equivalentes ao pacote de rotas do fiscal
   * @param routesAuthorization
   * @param action
   * @param params
   * @param url_name
   * @returns
   */
  validarAdicao(
    routesAuthorization: IRoute[],
    action: string,
    params = '',
    url_name: string
  ): boolean {
    if (routesAuthorization && routesAuthorization.length > 0) {
      const url_return = routesAuthorization.find(
        route => route.url === url_name && route.method === action
      );
      return !!url_return;
    }
  }

  checkPlano(plano: string) {
    plano = plano
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
    if (plano.includes('PRODUCAO')) return 'PRODUCAO';
    else if (plano.includes('COMERCIAL')) return 'COMERCIAL';
    else if (plano.includes('FISCAL')) return 'FISCAL';
    else if (plano.includes('FINANCEIRO')) return 'FINANCEIRO';
    else return 'UNKNOWN';
  }

  isUserAdmin() {
    const user = this.tokenService.getUser() as User;
    if (user) {
      const roleAdmin = user.roles.find(
        rl => rl.name.toUpperCase() === 'ADMIN'
      );
      return roleAdmin;
    }
    return false;
  }

  isMultiploDeDois(index: number) {
    return index % 2 === 0;
  }

  checkSubPassosConcluiu(subPassos: ISubPasso[]) {
    return subPassos.filter(it => it.concluido).length === subPassos.length;
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const txtMsg = showDefaultMsg
      ? `Identificamos o erro ${err.status} - ${err.statusText} no processamento dos dados!`
      : err.error;
    this.errorObj.message = txtMsg;
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      matDialog: this.matDialog,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      vlMsgDefault: txtMsg,
      dialogComponent: ConfirmDialogComponent,
      dialogData: {
        config: {
          data: {
            title: 'Aviso',
            icon: 'warning',
            bodyMessage: txtMsg,
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          width: '500px'
        }
      }
    } as IErroMessages);
    errorMsg.showMessageObject(txtMsg);
    // errorMsg.checkError();
  }
}
